/**
 * O contrato completo por expansão (E153.F3, ADR-0104 §2.6): o que a rota devolve, como os
 * compositores leem, sem reescrita da tela.
 */
import type { ResultadoDoCasoData } from '@/lib/resultadoAuditado';

import { preencher, t } from './textos';

export function ContratoJson({ dados }: { dados: ResultadoDoCasoData }): JSX.Element {
  return (
    <details className="border border-border p-sc-3" data-testid="resultado-contrato">
      <summary className="cursor-pointer text-body-md text-fg">{t.contrato.titulo}</summary>
      <p className="mt-sc-2 text-body-sm text-fg-muted">
        {t.contrato.texto}
        {dados.resultado !== null
          ? ` ${preencher(t.contrato.esquema, { schema: dados.resultado.schema })}`
          : ''}
      </p>
      <pre
        className="mt-sc-2 max-h-[32rem] overflow-auto bg-surface-2 p-sc-3 text-caption text-fg"
        data-testid="resultado-contrato-json"
      >
        {JSON.stringify(dados, null, 2)}
      </pre>
    </details>
  );
}
